import { useState, useEffect } from 'react'
import api from '../utils/api'
import { useAuth } from '../contexts/AuthContext'

export const useNotificationPolling = () => {
  const { isAuthenticated } = useAuth()
  const [unreadCount, setUnreadCount] = useState(0)

  const fetchUnread = async () => {
    if (!isAuthenticated) return
    try {
      const res = await api.get('/notifications/unread-count')
      if (res.data && typeof res.data.count === 'number') {
        setUnreadCount(res.data.count)
      }
    } catch {
      // ignore
    }
  }

  useEffect(() => {
    fetchUnread()
    const interval = setInterval(fetchUnread, 30000)
    return () => clearInterval(interval)
  }, [isAuthenticated])

  return { unreadCount, refresh: fetchUnread }
}
